module.exports = __webpack_public_path__ + "static/media/Daniela.738b2952.png";